var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "home" }, [
    _c(
      "div",
      { staticClass: "banner" },
      [
        _c("v-img", {
          staticClass: "hidden-md-and-up",
          staticStyle: { cursor: "pointer" },
          attrs: {
            contain: "",
            "max-height": "400px",
            src: require("../../../assets/mobile.png"),
            alt: "Banner"
          },
          on: { click: _vm.redirect }
        }),
        _c("v-img", {
          staticClass: "hidden-sm-and-down",
          staticStyle: { cursor: "pointer" },
          attrs: {
            contain: "",
            "max-height": "400px",
            src: require("../../../assets/desktop.png"),
            alt: "Banner"
          },
          on: { click: _vm.redirect }
        }),
        _c(
          "div",
          { staticClass: "bannerLine" },
          [
            _vm._m(0),
            _c("v-divider", {
              staticClass: "mx-2",
              attrs: { color: "#fff", vertical: "" }
            }),
            _vm._m(1)
          ],
          1
        ),
        _c("div", [_c("ExamList")], 1),
        _c(
          "v-btn",
          {
            staticStyle: { position: "fixed", bottom: "4rem", right: "1rem" },
            attrs: {
              href: "https://api.whatsapp.com/send?phone=5511945022666",
              target: "_blank",
              color: "green",
              dark: "",
              fab: ""
            }
          },
          [
            _c("v-icon", { attrs: { color: "white", "x-large": "" } }, [
              _vm._v("mdi-whatsapp")
            ])
          ],
          1
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "text" }, [
      _vm._v(" TODAS AS INFORMAÇÕES "),
      _c("br"),
      _vm._v(" SOBRE SEU EXAME AQUI ")
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "text" }, [
      _vm._v(" LAUDO INSERIDO NO "),
      _c("br"),
      _vm._v(" RENACH AUTOMATICAMENTE ")
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }